module.exports = __webpack_public_path__ + "static/media/img_background_obbar.019158c7.png";